import { iErrorEvent, iErrorEventHandler, LogLevel } from './emitter';

export class ConsoleErrorLogger implements iErrorEventHandler {
  constructor() {}

  handle(event: iErrorEvent): void {
    const level = event.loglevel ?? LogLevel.Error;
    let log = `[${level}] ${event.error} (Error page?: ${!event.disableErrorNavigator})`;
    if (event.message) {
      log += `\nMessage: ${event.message}`;
    }
    if (event.context) {
      log += `\nContext: ${JSON.stringify(event.context)}`;
    }
    if (level === LogLevel.Info) {
      console.info(log);
    } else if (level === LogLevel.Warning) {
      console.warn(log);
    } else {
      console.error(log);
    }
  }
}
